import { useEffect, useState } from 'react'

type Matcher = (event: KeyboardEvent) => boolean

export const useShortcut = (match: Matcher): boolean => {
  const [isPressed, setIsPressed] = useState(false)

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent): void => {
      if (match(event)) {
        setIsPressed(true)
        event.preventDefault()
        event.stopPropagation()
      }
    }
    const handleKeyUp = (): void => {
      setIsPressed(false)
    }
    document.addEventListener('keydown', handleKeyDown)
    document.addEventListener('keyup', handleKeyUp)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.removeEventListener('keyup', handleKeyUp)
    }
  }, [match])

  return isPressed
}
